// CLEAN-004: the currencies casavello supports. Only pounds and euro.
// Plain CommonJS. This file exists twice, byte for byte: services/currencies.js (server) and
// frontend/src/utils/currencies.js (browser; CRA cannot import outside src/). A test fails if the two ever differ.

const ALLOWED_CURRENCIES = ['GBP', 'EUR'];
const CURRENCY_ERROR = 'Currency must be GBP or EUR.';

// -> { empty, valid, value }   value is 'GBP' or 'EUR' (upper case) when valid, otherwise null
function validateCurrency(raw) {
  if (raw === undefined || raw === null || (typeof raw === 'string' && raw.trim() === '')) return { empty: true, valid: false, value: null };
  if (typeof raw !== 'string') return { empty: false, valid: false, value: null };
  const v = raw.trim().toUpperCase();
  return ALLOWED_CURRENCIES.includes(v) ? { empty: false, valid: true, value: v } : { empty: false, valid: false, value: null };
}

const isAllowedCurrency = (raw) => validateCurrency(raw).valid;

module.exports = { ALLOWED_CURRENCIES, CURRENCY_ERROR, validateCurrency, isAllowedCurrency };
